import { ErrorInfo } from "react";
import { isDevEnvironment } from "./utils.js";

const sendErrorToSentry = async (error: Error) => {
  const Sentry = await import("@sentry/browser");

  Sentry.init({
    dsn: "https://ea36ef58392c8724ae96f6a2f11035d2@o4508256406208512.ingest.de.sentry.io/4508357975736400",
    enabled: !isDevEnvironment,
    ignoreErrors: [
      // TODO: find a better way to exclude this error
      "Request failed with status code 401",
    ],
  });

  Sentry.captureException(error);
};

export const registerErrorReporting = () => {
  // Skip error reporting on legacy browsers
  // (which don’t support Object.fromEntries).
  if (!("fromEntries" in Object)) {
    return;
  }

  const onFirstError = (event: ErrorEvent) => {
    sendErrorToSentry(event.error);
    window.removeEventListener("error", onFirstError);
  };

  window.addEventListener("error", onFirstError);
};

export const trackErrorWithService = (error: Error, errorInfo?: ErrorInfo) => {
  console.error(error, errorInfo);
  sendErrorToSentry(error);
};
